export default {
  caption: {
    class: [
      // Flex
      'flex flex-col',
      'gap-1',
    ],
  },
  content: {
    class: 'p-0',
  },
  footer: {
    class: 'p-0',
  },
  root: {
    class: [
      // Flex
      'flex flex-col',

      // Shape
      '!rounded-lg',

      // Color
      'bg-surface-0 dark:bg-surface-900',
      'text-surface-700 dark:text-surface-0',
    ],
  },
  subtitle: {
    class: [
      // Font
      'font-normal',

      // Spacing
      'mb-0',

      // Color
      'text-surface-600 dark:text-surface-0/60',
    ],
  },
  title: {
    class: 'font-semibold mb-0',
  },
}
